/**
 * Device type conflict of an inspection (HCIT-943): masterdata-svc rejected the site type correction of the device
 * type chosen in the SmartLift app (HCIT-912), e.g. "Aufzug" for a unit listed as escalator or gate. disposition-svc
 * stores the flag `deviceTypeConflict` and a message; the office corrects the site type and checks again.
 *
 * Pure functions without store or REST access, so they can be tested without a component.
 */

export const CONFLICT = "masterdata.site.deviceType.conflict";
export const NOT_FOUND = "masterdata.site.notfound";

/** Device types of the app (DeviceTypeEnum of disposition-svc). */
const DEVICE_TYPES = [ "ELEVATOR", "ESCALATOR" ];

export default {
    /** Whether the inspection has an open conflict; the flag decides, older messages may remain. */
    isOpen (inspection) {
        return !!inspection && inspection.deviceTypeConflict === true;
    },

    /** The parameters of a message (disposition-svc joins them with ";"). */
    parameters (message) {
        return message && message.parameter ? String(message.parameter).split(";") : [];
    },

    /** The message of the conflict (conflict before "unit not found"), or null. */
    message (inspection) {
        const messages = inspection && inspection.messages ? inspection.messages : [];
        return messages.find(m => m.errorId === CONFLICT) || messages.find(m => m.errorId === NOT_FOUND) || null;
    },

    /** The name of a site type id from the master data enumerations; the id if it is unknown. */
    siteTypeName (siteTypes, id) {
        const type = (siteTypes || []).find(t => String(t.id) === String(id));
        return type ? type.name : id;
    },

    /**
     * The parameters of a message for its translation: for the conflict the device type of the app and the site type
     * by name (`label(key)` translates the device type); other messages keep theirs.
     */
    messageParameters (message, siteTypes, label) {
        const parameters = this.parameters(message);
        if (!message || message.errorId !== CONFLICT) {
            return parameters;
        }

        const deviceType = parameters[0];
        return [
            DEVICE_TYPES.includes(deviceType) && label ? label(deviceType) : deviceType,
            this.siteTypeName(siteTypes, parameters[1]),
        ];
    },

    /** Whether a unit of the inspection lists has a conflict (filter "Typ-Konflikte"). */
    unitHasConflict (unit) {
        return !!unit && unit.deviceTypeConflict === true;
    },
}
